import cn from 'classnames'
import { configuration } from 'mmfintech-checkout-commons'
import { getCurrencyImageUrl } from 'mmfintech-commons'

import './CurrencyIcon.scss'

interface CurrencyIconProps {
  currency: string
  size?: string
  circle?: boolean
  className?: string
}

export const CurrencyIcon = ({ currency, size = '26px', circle, className }: CurrencyIconProps) => (
  <div className={cn('currency-icon-wrapper', className, { circle })} style={{ width: size, height: size }}>
    <img src={`${configuration.readBackendConfig()}${getCurrencyImageUrl(currency, 'svg')}`} alt='' />
  </div>
)
